import React from 'react';
import { Button, Header, Icon, Loader, Popup, Table } from 'semantic-ui-react';
import { FiltersOnStyle, IconHeader } from '../../Professor/ProfessorInputGrades/css';
import CreateNewMobility from './CreateNewMobility';
import axios from 'axios';
import MobilityDetails from './MobilityDetails';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import EditMobility from './EditMobility';

export default class MobilityList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            addMobility: false,
            mobilities: [],
            mob: null,
            mobility: {},
            condition: true,
            showEditMode: false,
            confirmation: false,
            step: 0,
            student: JSON.parse(localStorage.getItem('student')),
            limitation: this.props.limitation,
        };
        this.handleClick = this.handleClick.bind(this);
        this.getMobility = this.getMobility.bind(this);
        this.deleteMobility = this.deleteMobility.bind(this);
    }

    handleClick(condition) {
        this.setState({ condition });
    }


    componentDidMount() {
        this.setState({ limitation: this.props.limitation });
        this.getMobility();
    }

    getMobility() {
        this.setState({ loader: true });
        axios.get(`/student-study-program-mobility/by-ssp/${this.state.student.id}/`)
            .then(res => {
                let mobilities = res.data;
                this.setState({ mobilities, loader: false });
            });
    }

    deleteMobility(mobilityId, optLock) {
        this.setState({ loader: true });
        let obj = {
            id: mobilityId,
            optLock
        };
        axios.delete(`/student-study-program-mobility/delete/${mobilityId}/`, { data: obj })
            .then((res) => {
                this.setState({ loader: false, confirmation: false });
                toast('Uspješno ste izbrisali mobilnost!');
                this.getMobility();
            }).catch(err => {
                this.setState({ loader: false });
                toast('Došlo je do greške! Mobilnost nije izbrisana! Provjerite da li su sve ocjene, praksa i predmeti za ovu mobilnost uklonjeni!');
            });
    }


    render() {
        if (this.state.step === 1) {
            return (
                <MobilityDetails limitation={this.props.limitation} />
            );
        }
        return (
            <div>
                {!this.state.onButtonClick && !this.state.limitation && !this.state.showEditMode ?
                    <Header style={IconHeader} floated="right"><Button
                        disabled={localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Support' || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu'}
                        floated="right"
                        icon
                        labelPosition="right"
                        color="blue"
                        size="small"
                        style={FiltersOnStyle}
                        onClick={() => { this.setState({ addMobility: true, onButtonClick: true, showEditClick: true }); window.scrollTo(0, 0); }}
                    ><Icon className="add" />
                        Dodavanje mobilnosti
                    </Button> </Header> : !this.state.limitation && <br />}


                {this.state.addMobility && <CreateNewMobility
                    getMobility={this.getMobility}
                    closeAddMode={() => this.setState({ addMobility: false, onButtonClick: false })}
                />}
                { !this.state.limitation && <br />}

                {this.state.showEditMode &&
                <EditMobility
                    closeEditMode={() => this.setState({ showEditMode: false, showEditClick: false })}
                    mobility={this.state.mobility}
                    getMobility={this.getMobility}
                />}
                { !this.state.limitation && <br />}

                {this.state.loader ? <div style={{ paddingTop: '50px' }}><Loader active inline="centered" /></div> :
                    this.state.mobilities.length ? <Table celled selectable compact >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Država</Table.HeaderCell>
                                <Table.HeaderCell colSpan="2"><Header as="h4" image>
                                    <Header.Content>
                                        Univerzitet
                                        <Header.Subheader>B/H/S / engleski jezik / izvorni jezik</Header.Subheader>
                                    </Header.Content>
                                </Header></Table.HeaderCell>
                                <Table.HeaderCell colSpan="2"><Header as="h4" image>
                                    <Header.Content>
                                        Fakultet/akademija
                                        <Header.Subheader>B/H/S / engleski jezik / izvorni jezik</Header.Subheader>
                                    </Header.Content>
                                </Header></Table.HeaderCell>
                                <Table.HeaderCell colSpan="2">Semestar (akademska godina)</Table.HeaderCell>
                                <Table.HeaderCell>Broj semestra</Table.HeaderCell>
                                <Table.HeaderCell colSpan="2" />
                            </Table.Row>
                        </Table.Header>

                        <Table.Body> {this.state.mobilities.map((el, index) =>
                            (<Table.Row key={index}>
                                <Table.Cell verticalAlign="middle">
                                    {el.country.name}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan="2">
                                    {el.universityName} / { el.translations.filter((e) => e.language === 'en')[0] ? el.translations.filter((e) => e.language === 'en')[0].universityName : '-'} / { el.translations.filter((e) => e.originalLanguage === true)[0] ? el.translations.filter((e) => e.originalLanguage === true)[0].universityName : '-'}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan="2">
                                    {el.facultyName} / { el.translations.filter((e) => e.language === 'en')[0] ? el.translations.filter((e) => e.language === 'en')[0].facultyName : '-'} / { el.translations.filter((e) => e.originalLanguage === true)[0] ? el.translations.filter((e) => e.originalLanguage === true)[0].facultyName : '-'}
                                    {/* {el.facultyName} / { el.translations.filter((e) => e.language === 'en')[0] ? el.translations.filter((e) => e.language === 'en')[0].facultyName : '-'} / { el.translations.filter((e) => e.language !== 'en')[0] ? el.translations.filter((e) => e.language !== 'en')[0].facultyName : '-'} */}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan="2">
                                    {el.semester.name.name} ({el.semester.academicYear.name})
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.studyProgramSemester.id} ({el.studyProgramSemester.name})
                                </Table.Cell>
                                <Table.Cell textAlign="center" verticalAlign="middle" colSpan="2">

                                    {this.state.confirmation === index ?
                                        <div>
                                            <h4>Jeste li sigurni?</h4>
                                            <Button.Group>
                                                <Button
                                                    basic="true"
                                                    color="blue"
                                                    onClick={() => this.deleteMobility(el.id, el.optLock)}
                                                > DA</Button>
                                                <Button
                                                    basic="true"
                                                    color="red"
                                                    onClick={() => { this.setState({ confirmation: false }); }}
                                                >  NE

                                                </Button>
                                            </Button.Group></div>
                                        : <div>
                                            <Popup
                                                content="Detalji mobilnosti"
                                                position="top center"
                                                trigger={
                                                    <Link to={{ component: { MobilityDetails } }}>
                                                        <Button
                                                            basic="true"
                                                            circular
                                                            icon="align justify"
                                                            size="small"
                                                            color="blue"
                                                            onClick={() => {
                                                                this.setState({ step: 1, mob: el, });
                                                                localStorage.setItem('mob', JSON.stringify(el));
                                                            }}
                                                        />
                                                    </Link>}
                                            />
                                            <Popup
                                                content="Izmjena mobilnosti"
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        disabled={this.state.limitation || localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Support' || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu'}
                                                        basic="true"
                                                        circular
                                                        icon="pencil"
                                                        size="small"
                                                        color="green"
                                                        onClick={() => {
                                                            this.setState({ showEditMode: true, mobility: el });
                                                            window.scrollTo(0, 0);
                                                        }}
                                                    >
                                                    </Button>}
                                            />
                                            <Popup
                                                content="Brisanje mobilnosti"
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        disabled={this.state.limitation || localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Support' || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu'}
                                                        basic="true"
                                                        circular
                                                        icon="trash alternate"
                                                        size="small"
                                                        color="red"
                                                        onClick={() => this.setState({ confirmation: index })}
                                                    />}
                                            />
                                        </div>}
                                </Table.Cell>
                            </Table.Row>))}
                        </Table.Body>
                    </Table>
                        : <p>Nema unesenih podataka o mobilnosti za ovog studenta.</p>}
                <ToastContainer hideProgressBar />
            </div>);
    }
}




// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/MobilityList.js